import { CANDLE_BODY_WIDTH_RATIO } from "../constants";
import { RECT_WIDTH_SLOTS } from "../gl/rectRenderer";

/**
 * Width of a 1 CSS px line in whole device pixels.
 *
 * @param {number} pixelRatio
 * @returns {number}
 */
export const lineWidthPx = (pixelRatio) => Math.max(1, Math.floor(pixelRatio));

/**
 * Width of a candle body in whole device pixels, not narrower than `minWidth`.
 *
 * @param {number} barSpacing - CSS px
 * @param {number} pixelRatio
 * @param {number} minWidth - device px
 * @returns {number}
 */
export const bodyWidthPx = (barSpacing, pixelRatio, minWidth) =>
  Math.max(minWidth, Math.floor(barSpacing * pixelRatio * CANDLE_BODY_WIDTH_RATIO));

/**
 * Left edge of a rectangle of `width` centred on the snapped bar x.
 *
 * @param {number} width - device px
 * @returns {number}
 */
export const centredOffset = (width) => -Math.floor(width / 2);

/**
 * Shape table of the rect renderer (see rectRenderer `shapes`).
 *
 * @param {Array<[number, number]>} slots - [width, left-edge offset] per shape slot, device px
 * @param {number} minHeight - device px
 * @returns {{ widths: Float32Array, offsets: Float32Array, minHeight: number }}
 */
export const buildRectShapes = (slots, minHeight) => {
  const widths = new Float32Array(RECT_WIDTH_SLOTS);
  const offsets = new Float32Array(RECT_WIDTH_SLOTS);

  slots.forEach(([width, offset], slot) => {
    widths[slot] = width;
    offsets[slot] = offset;
  });

  return { widths, offsets, minHeight };
};
